import API from "../config/api.js";

export const GlSubHeaderservice = {
    getAccountTypes() {
        return API.get("/api/gl-sub/GlAccountTypes");
    },
    async AddGlSubHeader(formData){
        
            const response = await API.post('/api/gl-sub/create', formData);
            return response.data; 
          
    }

}